import { FormBuilder, FormControl, Validators } from '@angular/forms';

import { SupportCategories } from '../../models';

export const EMPTY_FINANCE_PLACEHOLDER_KEY = 'supportForm.question.financePlaceholderEmpty';

export const getSupportFormGroup = (formBuilder: FormBuilder, category: SupportCategories) => {
  return formBuilder.group({
    text: new FormControl('', Validators.required),
    images: new FormControl([]),
    course: new FormControl(null),
    subject: new FormControl(null, category === SupportCategories.education ? Validators.required : null),
    financialCategory: new FormControl(null, category === SupportCategories.finance ? Validators.required : null),
    source: new FormControl(category),
    extraInformation: formBuilder.group({
      location_id: new FormControl(null, category === SupportCategories.office ? Validators.required : null),
      office_space: new FormControl(null),
      office_floor: new FormControl(null),
    }),
  });
};
